import { canCreateOrUpdate } from './validators/functions/can-create-or-update.function';
import { canPerformAction } from './validators/functions/can-perform-action.function';

export * from './dtos/create-vehicle-damage.dto';
export * from './dtos/update-vehicle-damage.dto';
export * from './dtos/vehicle-damage-links.dto';
export * from './dtos/vehicle-damage-list.dto';
export * from './dtos/vehicle-damage-record.dto';
export * from './dtos/vehicle-damage-activity-event.dto';
export * from './dtos/vehicle-damage-activity-event-hydration.dto';
export * from './dtos/vehicle-damage-search.dto';
export * from './dtos/vehicle-damages-stats.dto';

export * from './enums/vehicle-damage-fault.enum';
export * from './enums/vehicle-damage-record-category.enum';
export * from './enums/vehicle-damage-severity.enum';
export * from './enums/vehicle-damage-status.enum';
export * from './enums/vehicle-damage-type.enum';
export * from './enums/vehicle-damage-action.enum';

export * from './functions/vehicle-damage-status-to-color.function';

export * from './types/vehicle-damages-filters';

export * from './validators/schemas/create-vehicle-damage.schema';
export * from './validators/schemas/update-vehicle-damage.schema';

export const vehicleDamageValidators = { canCreateOrUpdate, canPerformAction };
